import { Button, Checkbox, Form, Input } from "antd";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  postMAO,
  getMAOFromList,
  editMAO,
  emptyMAOSelecionado,
} from "../../actions";
import "../../../styles.scss";

const CadastroMAOForm = (props) => {
  const [form] = Form.useForm();
  const [mode, setMode] = useState("new");
  const [maoSelecionado, setMaoSelecionado] = useState({});
  const [active, setActive] = useState(false);
  const [maoDefault, setMaoDefault] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (maoSelecionado) setMode("edit");
    if (props.maoSelecionado) setMaoSelecionado(props.maoSelecionado);
    setEdit(props.maoSelecionado);
  }, [JSON.stringify(props.maoSelecionado)]);

  const setEdit = (maoSelecionado) => {
    if (mode == "edit" || props.maoSelecionado) {
      form.setFieldsValue({
        maoCode: maoSelecionado.id,
        maoName: maoSelecionado.nome,
        maoActive: maoSelecionado.ativo,
        maoDefault: maoSelecionado.padrao,
      });
      setActive(maoSelecionado.ativo);
      setMaoDefault(maoSelecionado.padrao);
    }
  };

  const handleEdit = () => {
    setLoading(true);
    form.validateFields().then((values) => {
      let newMAO = {
        id: values.maoCode,
        nome: values.maoName,
        ativo: active,
        padrao: maoDefault,
      };
      editMAO(values.maoCode, newMAO, props.dispatch, setLoading);
      form.resetFields();
    });
  };

  const handleNew = () => {
    setLoading(true);
    form.validateFields().then((values) => {
      let newMAO = {
        id: values.maoCode,
        nome: values.maoName,
        ativo: active,
        padrao: maoDefault,
      };
      postMAO(newMAO, props.dispatch, setLoading);
      form.resetFields();
    });
  };

  const checkboxOnChange = (e) => {
    if (e.target.id === "maoActive") {
      setActive(e.target.checked);
    } else {
      setMaoDefault(e.target.checked);
    }
  };

  return (
    <div>
      <Form
        form={form}
        onFinish={mode === "new" ? () => handleNew() : () => handleEdit()}
      >
        <Form.Item label="Código do MAO" name="maoCode">
          <Input type="number" />
        </Form.Item>
        <Form.Item label="MAO" name="maoName">
          <Input />
        </Form.Item>
        <Form.Item label="Ativo" name="maoActive">
          <Checkbox checked={active} onChange={checkboxOnChange} />
        </Form.Item>
        <Form.Item label="Padrão para químicos" name="maoDefault">
          <Checkbox checked={maoDefault} onChange={checkboxOnChange} />
        </Form.Item>

        <div className="mao-button-div">
          {!maoSelecionado.nome ? (
            <Button loading={loading} onClick={() => handleNew()}>
              Salvar
            </Button>
          ) : (
            ""
          )}
          {maoSelecionado.nome ? (
            <React.Fragment>
              <Button loading={loading} onClick={() => handleEdit()}>
                Salvar
              </Button>
            </React.Fragment>
          ) : (
            ""
          )}
        </div>
      </Form>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    maoSelecionado: state.gestorDN.maoSelecionado,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ...dispatch,
    ...bindActionCreators({
      getMAOFromList,
      emptyMAOSelecionado,
    }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CadastroMAOForm);
